import { Chip, Tooltip } from "@mui/material";
import { cmToFeetInchesObject } from "../../constants/profileData";

// Function to create chips for filters
const AppliedFiltersRenderer = ({filters, resetIndividualFilter, onClickAction}) => {
  
  const chips = [];

  // Handle age filter separately if it's a special case
  if (filters.ageFilterState && filters.ageFilterState.length === 2) {
    chips.push(
      <Chip
        label={`Age: ${filters.ageFilterState[0]} - ${filters.ageFilterState[1]}`}
        // onDelete={() => handleDeleteFilter('ageFilterState')}
        key="ageFilterState"
        sx={{ margin: '3px' }}
				onClick={() => onClickAction("ageFilterState")}
      />
    );
  }
  if (filters.heightFilterState) {
    var currentMinHeightCm = filters.heightFilterState[0], currentMaxHeightCm = filters.heightFilterState[1];
    const currentMinFtInch = cmToFeetInchesObject(currentMinHeightCm);
    const currentMaxFtInch = cmToFeetInchesObject(currentMaxHeightCm);
    chips.push(
      <Chip
        label={`
          Height: ${currentMinFtInch.feet} ft ${currentMinFtInch.inches} in -
          ${currentMaxFtInch.feet} ft ${currentMaxFtInch.inches} in`}
        key="heightFilterState"
        sx={{ margin: '3px' }}
				onClick={() => onClickAction("heightFilterState")}
      />
    );
  }

  // Loop through each key in the filters object (except ageFilterState)
   Object.keys(filters).forEach((filterKey) => {
      if (filterKey !== 'ageFilterState' && filterKey !== 'heightFilterState' ) {
        const filter = filters[filterKey];
        const filterName = filter['filterName'];
        const selectedLabels = filter.filters
          .filter(filterOption => filterOption.checked)
          .map(filterOption => filterOption.label)
          .join(', ');

        // If there are selected filters, add them to the chips array
        if (selectedLabels && filter.selectedCount !== filter.filters.length) {
          chips.push(
            <Tooltip title={`${filterName}: ${selectedLabels}`} key={filterKey}>
              <Chip
                label={`${filterName}: ${selectedLabels}`}
                // onDelete={() => handleDeleteFilter(filterKey)}
                sx={{ margin: '3px' }}
                onDelete={() => resetIndividualFilter(filterKey)}
                onClick={() => onClickAction(filterKey)}
              />
            </Tooltip>
          );
        }
      }
    });

  return <>{chips}</>; // Return the chips wrapped in a fragment
};

export default AppliedFiltersRenderer